import React from 'react';
import styles from './Button.module.scss';

export { styles as ButtonStyles };

export const Button = ({ as: Component = 'button', className = '', type, ...props }) => {
    const componentProps = Component === 'button' ? { type: type || 'button' } : {};

    return <Component className={`${styles.button} ${className}`} {...componentProps} {...props} />;
};
// github vscode test
